type OrdenTrabajoFotosSalida = {
  urls_fotos_salida?: any;
  tipo_instalacion?: any;
  puntos_red_instalados?: string | number;
  puntos_red_no_instalados?: string | number;
  routers_adicionales_instalados?: string | number;
};

type FotosSalidaFormData = {
  puntos_red_instalados?: unknown;
  puntos_red_no_instalados?: unknown;
  routers_adicionales_instalados?: unknown;
};

export function getMissingRequiredSalidaPhotos(
  ordenTrabajo: OrdenTrabajoFotosSalida,
  data?: FotosSalidaFormData,
): string[] {
  const fotosSalida = ordenTrabajo?.urls_fotos_salida?.photosSalida || {};
  const missingPhotos: string[] = [];
  const requiredPhotos = [
    { label: "Foto Ubicación ONT", isLoaded: hasStoredPhoto(fotosSalida?.fotoUbicacionONT) },
    { label: "Foto Reserva", isLoaded: hasStoredPhoto(fotosSalida?.fotoReserva) },
    { label: "Foto Croquis Virtual", isLoaded: hasStoredPhoto(fotosSalida?.fotoCroquisVirtual) },
    { label: "Foto Test 5G", isLoaded: hasStoredPhoto(fotosSalida?.fotoTest5g) },
    { label: "Foto Potencia Interfaz ONT", isLoaded: hasStoredPhoto(fotosSalida?.fotoPotenciaONT) },
    { label: "Foto Hoja de Materiales", isLoaded: hasStoredPhoto(fotosSalida?.fotoMaterialesContrato) },
    { label: "Foto Progresiva Inicial", isLoaded: hasStoredPhoto(fotosSalida?.fotoPuntoInicial) },
    { label: "Foto Progresiva Final", isLoaded: hasStoredPhoto(fotosSalida?.fotoPuntoFinal) },
  ];

  if (!isTipoInstalacionNormal(ordenTrabajo?.tipo_instalacion)) {
    requiredPhotos.push({
      label: "Foto Tipo Instalación",
      isLoaded: hasStoredPhoto(fotosSalida?.fotoTipoInstalacion),
    });
  }

  requiredPhotos.forEach((photo) => {
    if (!photo.isLoaded) missingPhotos.push(photo.label);
  });

  const puntosRedInstalados = toPositiveInteger(
    data?.puntos_red_instalados ?? ordenTrabajo?.puntos_red_instalados,
  );
  const puntosRedNoInstalados = toPositiveInteger(
    data?.puntos_red_no_instalados ?? ordenTrabajo?.puntos_red_no_instalados,
  );
  const routersAdicionales = toPositiveInteger(
    data?.routers_adicionales_instalados ?? ordenTrabajo?.routers_adicionales_instalados,
  ) * 3;

  for (let index = 0; index < puntosRedInstalados; index++) {
    const key = `puntoRed${index + 1}`;
    if (!hasStoredPhoto(fotosSalida?.fotosAdicionales?.fotoPuntosRedInstalados?.[key])) {
      missingPhotos.push(`Foto Punto de Red ${index + 1}`);
    }
  }

  for (let index = 0; index < puntosRedNoInstalados; index++) {
    const key = `puntoRedNoInstalado${index + 1}`;
    if (!hasStoredPhoto(fotosSalida?.fotosAdicionales?.fotoPuntosRedNoInstalados?.[key])) {
      missingPhotos.push(`Foto Punto de Red No Instalado ${index + 1}`);
    }
  }

  for (let index = 0; index < routersAdicionales; index++) {
    const key = `routerAdicional${index + 1}`;
    if (!hasStoredPhoto(fotosSalida?.fotosAdicionales?.fotoRoutersAdicionalesInstalados?.[key])) {
      missingPhotos.push(`Foto Router Adicional ${index + 1}`);
    }
  }

  return missingPhotos;
}

export function normalizeSalidaPhotoName(photoName?: string | null): string {
  return String(photoName ?? "")
    .replace(/Punto Inicial/g, "Progresiva Inicial")
    .replace(/Punto Final/g, "Progresiva Final")
    .replace(/Punta Inicial/g, "Progresiva Inicial")
    .replace(/Punta Final/g, "Progresiva Final");
}

function hasStoredPhoto(photo?: {
  photoId?: string | null;
  photoUrl?: string | null;
  url?: string | null;
  id_archivos?: string | null;
} | null): boolean {
  return Boolean(photo?.photoId || photo?.photoUrl || photo?.url || photo?.id_archivos);
}

function toPositiveInteger(value?: unknown): number {
  const parsed = Number.parseInt(String(value ?? "0"), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function isTipoInstalacionNormal(tipoInstalacion?: any): boolean {
  const rawValue =
    typeof tipoInstalacion === "string"
      ? tipoInstalacion
      : tipoInstalacion?.codigo || tipoInstalacion?.nombre || "";

  return normalizarTexto(rawValue) === "NORMAL";
}

function normalizarTexto(value?: unknown): string {
  return String(value ?? "")
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}
